/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from "react";
import Publisher from "../core/publisher";
const publishers = new Map();
export const usePersistShard = (persistShard) => {
    if (typeof global !== "undefined") {
        if (!global.window) {
            return [persistShard.getFallbackData(), () => { }];
        }
    }
    const publisher = new Publisher();
    let data = JSON.parse((localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(persistShard.getKey())) || "null");
    const [state, setState] = useState(data || persistShard.getInitialValue());
    const id = persistShard.getId();
    useEffect(() => {
        var _a, _b, _c, _d;
        if (!id && persistShard.getKey())
            return;
        if (!publishers.has(id)) {
            publishers.set(id, publisher);
        }
        if (data === null) {
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(persistShard.getKey(), JSON.stringify(persistShard.getInitialValue()));
            data = persistShard.getInitialValue();
        }
        if ((_a = publishers.get(id)) === null || _a === void 0 ? void 0 : _a.getRecentlyData()) {
            setState((_b = publishers.get(id)) === null || _b === void 0 ? void 0 : _b.getRecentlyData());
        }
        else {
            setState((_c = data !== null && data !== void 0 ? data : persistShard.getInitialValue()) !== null && _c !== void 0 ? _c : persistShard.getFallbackData());
        }
        const subscribe = (_d = publishers.get(id)) === null || _d === void 0 ? void 0 : _d.subscribe((v) => {
            setState(v);
        });
        return () => subscribe === null || subscribe === void 0 ? void 0 : subscribe.unsubscribe();
    }, [id]);
    return [
        state,
        (v) => {
            var _a, _b;
            if (typeof v === "function") {
                const newValue = v(state);
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(persistShard.getKey(), JSON.stringify(newValue));
                (_a = publishers.get(id)) === null || _a === void 0 ? void 0 : _a.publish(newValue);
                return;
            }
            (_b = publishers.get(id)) === null || _b === void 0 ? void 0 : _b.publish(v);
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(persistShard.getKey(), JSON.stringify(v));
        },
    ];
};
//# sourceMappingURL=usePersistShard.js.map